import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import ProjectCard from './ProjectCard';
import styles from './ProjectList.module.scss';

const cx = classNames.bind(styles);

function ProjectList({ projects, isVisible }) {
  return (
    <div className={cx('project-list', { 'visible': isVisible })}>
      {projects.map((project, index) => (
        <Link 
          to={`/projects/${project.id}`} 
          key={project.id} 
          className={cx('project-card-link')}
        >
          <ProjectCard 
            project={project} 
            delay={index * 0.1}
          />
        </Link>
      ))}
    </div>
  );
}

export default ProjectList;